import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { KeycloakService } from '../../auth/services/keycloak.service';
import { PortalService } from '../../portal/services/portal.service';

@Component({
  selector: 'kmt-topbar',
  imports: [ButtonModule],
  templateUrl: './topbar.html',
  styleUrl: './topbar.css',
})
export class TopbarComponent {
  constructor(
    public readonly keycloak: KeycloakService,
    public readonly portal: PortalService,
  ) {}
}
